import { ActionTypes } from '../actions';

const INITIAL_STATE = {
  clicked: false,
  currPage: null,
  endPage: null,
};

const ModalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.OPEN_MODAL:
      return {
        clicked: true,
        currPage: action.payload.currPage,
      };
    case ActionTypes.CLOSE_MODAL:
      return {
        clicked: false,
        currPage: null,
      };
    case ActionTypes.SWITCH_MODAL_PAGE:
      return {
        ...state,
        currPage: action.payload.currPage,
        endPage: action.payload.endPage,
      };
    default:
      return state;
  }
};

export default ModalReducer;
